import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-itemployee-review-form',
  templateUrl: './itemployee-review-form.component.html',
  styleUrls: ['./itemployee-review-form.component.scss']
})
export class ITEmployeeReviewFormComponent implements OnInit {

  constructor(public appservice:AppService,public router:Router,public toastr:ToastrService) { }
  public Ticket:any=[];

  onformload(){
    this.appservice.getTable("api/Transaction/GetEmployeeTicket?id="+this.appservice.TicketEdituser).subscribe({
    next:(res:any)=>{
      if(res){
      const a =JSON.parse(res);
        this.Ticket=a[0];
       
          console.log("The Datas are ",this.Ticket)
      }
    },
    error:(err:any)=>{
      this.toastr.error(err,"Error");
    }
  })
  }
    fullImage: string | null = null;
openPreview(img: string) {
  this.fullImage = img;
}
  closePreview() {
  this.fullImage = null;
}
    Pending(data){
    
      this.appservice.getTable("api/Transaction/updateTicketforUser?id="+this.appservice.TicketEdituser+"&status="+data).subscribe((res:any)=>{
        if(res=="True"){
  this.toastr.success("Ticket Updated as Pending");
  this.onformload();
  this.appservice.goback();
        }
      });
  }
  ngOnInit(): void {
     this.onformload();
  }

}
